import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { Card, CardContent } from '@/components/ui/card'
import { buildPath } from '@/routes'
import { Outlet } from 'react-router'

export function InsuranceUsersLayout() {
  return (
    <>
      <Breadcrumb
        label="Insurance Users"
        path={buildPath('/insurance/users')}
      />

      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </>
  )
}
